<template>
  <router-link
    :to="`/scheduleDetail/${hotMatchItem.match_id}/${hotMatchItem.sport_id}`"
  >
    <div class="live-item-s">
      <header class="match-header flex-between flex-middle-only">
        <div class="flex-middle-only">
          <img
            style="height: 0.2rem; margin-right: 0.1rem"
            :src="hotMatchItem.sport_id === 1 ? football : basketball"
            alt=""
          />
          <span style="font-size: 14px; color: #fff">
            <!-- {{ hotMatchItem.event_name_zh }} -->
            <!-- {{ hotMatchItem[titleObj[this.$i18n.locale || "en-US"]] }} -->
            {{
              this.$i18n.locale === "zh-CN"
                ? hotMatchItem.comp_short_zh
                : this.$i18n.locale === "vi-VN"
                ? hotMatchItem.comp_short_vi
                : hotMatchItem.comp_short_en
            }}
          </span>
        </div>

        <div
          class="flex-middle-only"
          v-if="hotMatchItem.liveAnchors && hotMatchItem.liveAnchors.length > 0"
        >
          <div
            class="avatar-content"
            v-for="anchor of hotMatchItem.liveAnchors"
            :key="anchor.anchor_id"
          >
            <img
              style="width: 100%; height: 100%"
              :src="anchor.anchor_avatar"
              alt=""
            />
          </div>
        </div>

        <span v-else style="color: rgba(255, 202, 214, 1)">{{
          moment(hotMatchItem.time * 1000).format("MM-DD")
        }}</span>
      </header>

      <el-row class="flex-middle-only" style="margin-top: 0.22rem">
        <el-col :span="8" class="flex-end flex-middle-only">
          <div class="team-logo flex-middle">
            <img :src="hotMatchItem.home_team_logo" alt="" />
          </div>
          <p class="score-text">
            {{
              [1, 3].includes(hotMatchItem.match_status)
                ? hotMatchItem.home_score
                : "-"
            }}
          </p>
        </el-col>
        <el-col
          :span="8"
          class="flex-middle"
          style="font-size: 0.2rem; color: #999"
          >vs</el-col
        >
        <el-col :span="8" class="flex-middle-only">
          <p class="score-text">
            {{
              [1, 3].includes(hotMatchItem.match_status)
                ? hotMatchItem.away_score
                : "-"
            }}
          </p>
          <div class="team-logo flex-middle">
            <img :src="hotMatchItem.away_team_logo" alt="" />
          </div>
        </el-col>
      </el-row>

      <el-row style="margin-top: 0.12rem" class="flex-middle-only">
        <el-col :span="8" class="team-name">
          <!-- {{ hotMatchItem.home_team_name_zh }} -->
          {{
            this.$i18n.locale === "zh-CN"
              ? hotMatchItem.home_team_name_zh
              : this.$i18n.locale === "vi-VN"
              ? hotMatchItem.home_team_name_vi
              : hotMatchItem.home_team_name_en
          }}
        </el-col>
        <el-col :span="8" class="flex-middle">
          <div
            class="in-playing flex-middle"
            v-if="hotMatchItem.match_status === 1 || hotMatchItem.lives"
          >
            <img
              style="width: 0.12rem; margin-right: 2px"
              :src="require('@/assets/live/ing.png')"
              alt=""
            />
            {{
              hotMatchItem.lives ? $t("common.living") : $t("common.processIng")
            }}
          </div>

          <!--马上开始-->
          <div
            class="upcoming flex-middle"
            v-if="hotMatchItem.match_status === 2"
          >
            <img
              style="width: 0.12rem; margin-right: 2px"
              :src="require('@/assets/live/willStart.png')"
              alt=""
            />
            {{ $t("pc.willStart") }}
          </div>

          <span v-if="hotMatchItem.match_status === 3" style="color: #999">{{
            $t("common.end")
          }}</span>
        </el-col>
        <el-col :span="8" class="team-name">
          <!-- {{ hotMatchItem.away_team_name_zh }} -->
          {{
            this.$i18n.locale === "zh-CN"
              ? hotMatchItem.away_team_name_zh
              : this.$i18n.locale === "vi-VN"
              ? hotMatchItem.away_team_name_vi
              : hotMatchItem.away_team_name_en
          }}
        </el-col>
      </el-row>
    </div>
  </router-link>
</template>

<script>
import moment from "moment";
const titleObj = {
  "zh-CN": "comp_short_zh",
  "en-US": "comp_short_en",
  "vi-VN": "comp_short_vi",
};

const nameObj = {
  "zh-CN": "home_team_name_zh",
  "en-US": "home_team_name_en",
  "vi-VN": "home_team_name_vi",
};

const nameAwayObj = {
  "zh-CN": "away_team_name_zh",
  "en-US": "away_team_name_en",
  "vi-VN": "away_team_name_vi",
};

export default {
  name: "live-item-s",
  props: {
    hotMatchItem: {
      type: Object,
      default() {
        return {};
      },
    },
  },
  data() {
    return {
      moment: moment,
    };
  },
  created() {
    this.football = require("./foolball.png");
    this.basketball = require("./basketball.png");
    this.default_f_logo = require("./img/default_logo_football.png");
    this.default_b_logo = require("./img/default_logo_basketball.png");
    console.log(this.$i18n.locale, "this.$i18n.locale");
  },
  methods: {
    enterRoom(live) {
      this.$router.push({
        path: `/liveMatchesTwo/${live.anchorid}`,
      });
    },
    showScore(status, type) {
      if (type === "basket") {
        return status > 1 && status < 11;
      } else {
        return status > 1 && status < 9;
      }
    },
    getMatchStatus(time) {
      const nowTime = new Date().getTime();
      return time * 1000 < nowTime;
    },
  },
};
</script>

<style scoped lang="scss">
.live-item-s {
  cursor: pointer;
  /* width: 340px; */
  height: 1.68rem;
  // background-color: #fff;
  border-radius: 8px;
  overflow: hidden;
  border: 1px solid rgba(226, 212, 212, 1);
  background: url("~@/assets/live/card_bg.png") no-repeat;
  background-size: 100% 100%;

  position: relative;

  &:hover {
    box-shadow: 0 0 8px rgba(145, 145, 145, 0.33);
    /* border-radius: 8px;
    // background-color: #fbfbfb;
    // background-clip: padding-box, border-box;
    // background-origin: padding-box, border-box;
    // background-image: linear-gradient(to right, #fff, #fff), linear-gradient(90deg, #29f19c 0%, #02a1f9 100%);
    // border: 1px solid transparent;
    border: 1px solid;
    border-image: linear-gradient(90deg, #fd3061 0%, #cf2d54 100%) 1;
    clip-path: inset(0 round 1px); */
  }

  .match-header {
    padding: 0 0.16rem;
    height: 0.48rem;
    border-bottom: 1px solid #f0f0f0;
    background: linear-gradient(90deg, #ff3541 0%, #d32e55 100%);
  }

  .in-playing {
    width: 0.8rem;
    height: 0.32rem;
    background: rgba(255, 223, 223, 1);
    border-radius: 4px;
    color: rgba(208, 45, 84, 1);
  }

  .upcoming {
    width: 0.8rem;
    height: 0.32rem;
    background: #fff4ec;
    border-radius: 4px;
    color: #ff8800;
  }

  .team-logo {
    width: 0.38rem;
    height: 0.38rem;
    background-color: #fff;
    //border: 1px solid #999;
    border-radius: 50%;

    img {
      width: 0.36rem;
      height: 0.36rem;
    }
  }

  .team-name {
    padding: 0 0.16rem;
    font-size: 0.14rem;
    color: #333;
    font-weight: 500;
    text-align: center;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .score-text {
    font-size: 0.2rem;
    font-weight: 500;
    color: #333;
    width: 0.3rem;
    text-align: center;
  }

  .anchor-logo {
    margin-left: 0.05rem;
    border-radius: 50%;
    width: 0.26rem;
    height: 0.26rem;
    border: 1px solid #26d99d;
  }

  .title {
    width: 100%;
    line-height: 0.22rem;
    font-size: 0.18rem;
    color: #333333;
    letter-spacing: 0;
    font-weight: 500;
    margin-top: 0.02rem;
    margin-bottom: 0.02rem;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .avatar-content {
    width: 0.28rem;
    height: 0.28rem;
    border-radius: 50%;
    overflow: hidden;
    border: 1px solid #fff;
    margin-left: -0.08rem;
  }
}
</style>
